<template>
  <div ref="wrapper" :style="{ position: 'relative' }">
    <div ref="content" :style="contentStyle">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StickyUntil',
  props: {
    stopAtId: {
      type: String,
      required: true
    },
    offset: {
      type: Number,
      default: 16
    },
    right: {
      type: Number,
      default: 16
    }
  },
  data() {
    return {
      mode: 'fixed', // 'fixed' or 'absolute'
      absoluteBottom: 0,
      height: 0
    };
  },
  computed: {
    contentStyle() {
      const base = {
        right: `${this.right}px`,
        zIndex: 9999,
        pointerEvents: 'auto',
        transform: 'translateZ(0)',
        willChange: 'transform'
      };

      if (this.mode === 'fixed') {
        return {
          position: 'fixed',
          bottom: `${this.offset}px`,
          ...base
        };
      } else {
        return {
          position: 'absolute',
          bottom: `${this.absoluteBottom}px`,
          ...base
        };
      }
    }
  },
  mounted() {
    this.height = this.$refs.content.offsetHeight;
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.update);
    this.update();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.update);
  },
  methods: {
    update() {
      this.height = this.$refs.content.offsetHeight;
      this.onScroll();
    },
    onScroll() {
      const stopEl = document.getElementById(this.stopAtId);
      const wrapperEl = this.$refs.wrapper;
      const contentEl = this.$refs.content;
      if (!stopEl || !wrapperEl || !contentEl) return;

      const stopRect = stopEl.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const widgetHeight = contentEl.offsetHeight;

      const widgetBottom = windowHeight - this.offset;
      const footerTop = stopRect.top;

      if (footerTop <= widgetBottom) {
        this.mode = 'absolute';

        const stopY = footerTop + window.scrollY;
        const wrapperY = wrapperEl.getBoundingClientRect().top + window.scrollY;
        // const bottomOffset = stopY - wrapperY - widgetHeight;
        const bottomOffset = stopY - wrapperY + 16;

        // console.log('bottomOffset', bottomOffset);
        this.absoluteBottom = bottomOffset;
      } else {
        this.mode = 'fixed';
      }
    }
  }
};
</script>

<style scoped>
/* никаких фонов и теней — задаются в слоте */
</style>
